import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { NgxSpinnerService } from "ngx-spinner";
import { Observable, throwError } from "rxjs";
import { tap, map, catchError, finalize } from "rxjs/operators";
import { Router } from "@angular/router";

@Injectable()
export class myInterceptor implements HttpInterceptor {
  private credentialsExceptions: string[] = [
    "security/auth/internal",
    "security/auth/afip",
    "security/auth/cidi",
    "security/logout",
    "notificacion/mailCodeValidation/send",
    "notificacion/mailCodeValidation/receive",
    "ftago-titulosejecutivos.s3.us-west-2.amazonaws.com",
    "s3.us-west-2.amazonaws.com/ftago-titulosejecutivos",
    "ftago.s3.amazonaws.com",
    "ftago-titulosejecutivos-no-prod.s3.us-west-2.amazonaws.com",
    "s3.us-west-2.amazonaws.com/ftago-titulosejecutivos-no-prod",
    "ftago-no-prod.s3.amazonaws.com",
  ];

  private spinnerExceptions: string[] = [
    "/externalSource/liquidacionExt",
    // "/externalSource/liquidacion",
    "liquidacion/reassignate",
    "/notificacion/count",
    "/documentacion/presignedPost",
    "/titEjec/uploads",
    "/ftago/titulosEjecutivos",
    "/liquidacion/ultEtapaLiq",
    "www.google-analytics.com",
    "honorario/informe",
  ];
  count = 0;
  updateEncode = 0;

  constructor(private router: Router, private spinner: NgxSpinnerService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    const currentToken = JSON.parse(localStorage.getItem("currentToken"));
    let currentTokenCidi;
    localStorage.getItem("CiDi")
      ? (currentTokenCidi = localStorage.getItem("CiDi"))
      : false;

    const credExclusion = this.credentialsExceptions
      .map((ex) => {
        return req.url.search(ex) === -1; // If search === -1 the route isn't an exception
      })
      .some((ex) => !ex);

    const spinnerExclusion = this.spinnerExceptions
      .map((ex) => {
        return req.url.search(ex) === -1; // If search === -1 the route isn't an exception
      })
      .some((ex) => !ex);
      
    if (!credExclusion) {
      req = req.clone({
        headers: new HttpHeaders({
            Authorization: `Bearer ${currentToken}`,
            UserId: currentUser.user_id,
            ProfileId: currentUser.idProfile,
            cuitProcu: currentUser.cuit,
            useriva: currentUser.user_iva,
            usernombre: currentUser.user_nombre,
            userjudment: currentUser.user_judgment,

        }),
      });

      if (currentTokenCidi) {
        req = req.clone({
          headers: req.headers.set("CiDi", currentTokenCidi),
        });
      }
        
    }

    if (!spinnerExclusion) {
      if (req.url.search("/titEjec/updateStateEncodeProcurador") !== -1) {
        this.spinner.hide();
        this.spinner.show("title-spinner");
      } else {
        this.spinner.show();
      }
    }
    this.count++;

    return next.handle(req).pipe(
      map(rs => {
        return rs;
      }),
      catchError((error: HttpErrorResponse) => {
        return throwError(error);
      }),
    finalize(() => {
        this.count--;
        if (this.count == 0) {
          this.spinner.hide();
          this.spinner.hide("title-spinner");
        }
      })
    );
  }
}
